import getApi from '../../api'
import { ApiMail, deserializeMailResponse } from './mapper'

export const getMail = (id: string) =>
  getApi().get<ApiMail>(`/mss/messages/${id}`).then(deserializeMailResponse)
